/**
 * To understand how it works and how to use it check out "Section Using the NgOnDestroy service" section here:
 * https://medium.com/angular-in-depth/why-you-have-to-unsubscribe-from-observable-92502d5639d0
 */
import { OnDestroy, Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class NgOnDestroy extends Subject<null> implements OnDestroy {
  ngOnDestroy() {
    this.next(null);
    this.complete();
  }
}
